<template>
  <div>
    <ca-heading text="Pagamento de Autônomo" />

    <ca-page>
      <ca-form
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row>
          <ca-col size="6">
            <ca-field label="Autônomo">
              <ca-search-select
                v-model="payment.selfEmployed.id"
                :on-fetch="onFetchSelfEmployedList"
                :on-fetch-success="onFetchSelfEmployedListSuccess"
                :on-load-more-button-click="onLoadMore"
                load-more
                required>
                <ca-option
                  v-for="selfEmployed in selfEmployedList"
                  :key="selfEmployed.id"
                  :value="selfEmployed.id">
                  {{ selfEmployed.selfEmployedName }}
                </ca-option>
              </ca-search-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Mês">
              <ca-monthpicker v-model="selectedDate"></ca-monthpicker>
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-row>
          <ca-col size="2">
            <ca-button
              :disabled="!payment.selfEmployed.id"
              size="small"
              theme="secondary"
              @click="openAddService">
              Adicionar serviço
            </ca-button>
          </ca-col>
        </ca-row>

        <ca-row vertical-offset="2">
          <ca-col>
            <ca-table>
              <ca-tr slot="header">
                <ca-th>Descrição</ca-th>
                <ca-th>Natureza</ca-th>
                <ca-th>Pagamento</ca-th>
                <ca-th></ca-th>
              </ca-tr>
              <ca-tr v-for="(movement, index) in payment.movements" :key="index">
                <ca-td>{{ movement.description }}</ca-td>
                <ca-td>{{ movement.eventNature.description }}</ca-td>
                <ca-td>{{ movement.paymentDate | caDate }}</ca-td>
                <ca-td>
                  <ca-button @click="onDeleteService(index)">Excluir</ca-button>
                </ca-td>
              </ca-tr>
            </ca-table>
          </ca-col>
        </ca-row>

        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col size="2">
              <ca-button full-width @click="goBack">
                Voltar
              </ca-button>
            </ca-col>
            <ca-col offset="8" size="2">
              <ca-submit-button v-if="payment.movements.length>0">
                Gerar pagamento
              </ca-submit-button>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import moment from 'moment';
import { getFormattedPeriod } from 'packages/common/utils/format';
import { getBoxInformationErrorMessage } from 'packages/common/utils';
import AddPaymentMovementModal from './modals/AddPaymentMovementModal';
import { generatePayment } from './paymentService';
import { getSelfEmployedList } from '../self-employed/selfEmployedService';

export default {
  name: 'PaymentFormPage',
  data() {
    return {
      payment: {
        selfEmployed: {},
        movements: [],
      },
      errorMessage: null,
      selfEmployedList: null,
      selectedDate: moment().format('DD/MM/YYYY'),
      page: 0,
    };
  },
  created() {
    this.onFetchSelfEmployedList().then(this.onFetchSelfEmployedListSuccess);
  },
  methods: {
    async onFetchSelfEmployedList() {
      return getSelfEmployedList({ page: this.page });
    },
    onFetchSelfEmployedListSuccess({ content }) {
      this.selfEmployedList = content;
    },
    onLoadMore() {
      this.page++;
      this.onFetchSelfEmployedList()
        .then(response => {
          this.selfEmployedList = this.selfEmployedList.concat(response.content);
        });
    },
    onSubmit() {
      const params = {
        selfEmployed: this.payment.selfEmployed,
        competence: getFormattedPeriod(this.selectedDate),
        movements: this.payment.movements,
      };
      return generatePayment(params);
    },
    onSubmitSuccess() {
      this.goBack();
      this.$toaster.success('Dados salvos com sucesso');
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
    openAddService() {
      this.$dialogModal(AddPaymentMovementModal, {
        on: {
          created: movement => this.payment.movements.push(movement),
        },
      }).open();
    },
    onDeleteService(index) {
      this.$delete(this.payment.movements, index);
    },
    goBack() {
      this.$router.push({ name: 'PaymentPage' });
    },
  },
};
</script>
